import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { fetchProfileView } from '@ego/api';
import styles from './UserCard.module.css';

export default function UserCard({ user }) {
  const initial = (user.name || user.handle || '?').charAt(0).toUpperCase();
  const prefetch = useCallback(() => {
    if (user.handle) fetchProfileView(user.handle).catch(() => {});
  }, [user.handle]);

  return (
    <Link to={`/${user.handle}`} className={styles.cardLink} onMouseEnter={prefetch}>
      <div className={styles.card}>
        <div className={styles.content}>
          {user.avatarUrl ? (
            <img src={user.avatarUrl} alt={user.name || user.handle || 'User avatar'} className={styles.avatar} loading="lazy" />
          ) : (
            <div className={styles.initial}>{initial}</div>
          )}
        </div>
        <div className={styles.caption}>
          <span className={styles.name}>{user.name || user.handle}</span>
          <span className={styles.stat}>
            {user.publicChannelsCount} channel{user.publicChannelsCount !== 1 ? 's' : ''}
          </span>
        </div>
      </div>
    </Link>
  );
}
